import React, { Component } from "react";
import classnames from "classnames";
import { action, observable } from "mobx";
import { observer } from "mobx-react";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@formant/ui-kit/src/components/ui/popover";
import { IconName } from "@formant/ui/component/common/Icon";

import { Menu } from "../common/Menu";
import { IMenuItem } from "../common/Menu/IMenuItem";
import { CircleButton } from "./CircleButton";
import { HeaderButton } from "./HeaderButton";
import { Hotkey } from "./hotkey/Hotkey";
import * as styles from "./MenuButton.scss";

export interface IMenuButtonProps extends ITestableComponentProps {
    items: IMenuItem[];
    collapsed?: boolean;
    header?: boolean;
    bottom?: boolean;
    className?: string;
    buttonClassName?: string;
    icon?: IconName;
    primary?: boolean;
    disabled?: boolean;
    onChanged?: (openState: boolean) => void;
}

@observer
export class MenuButton extends Component<IMenuButtonProps> {
    @observable
    private open: boolean = false;

    @action
    private handleOpenChange = (newOpen: boolean) => {
        this.open = newOpen;
        if (this.props.onChanged) {
            this.props.onChanged(newOpen);
        }
    };

    public render() {
        const {
            items,
            header,
            className,
            buttonClassName,
            icon,
            primary,
            disabled,
        } = this.props;

        if (items.length === 0) {
            return false;
        }

        return (
            <div
                className={classnames(
                    styles["menu-button"],
                    this.open && styles.open,
                    className,
                )}
            >
                <Popover open={this.open} onOpenChange={this.handleOpenChange}>
                    {header ? (
                        <PopoverTrigger className="block">
                            <HeaderButton
                                className={buttonClassName}
                                icon={icon || "more"}
                                disabled={disabled}
                                data-testid={this.props["data-testid"]}
                            />
                        </PopoverTrigger>
                    ) : (
                        <PopoverTrigger className="block">
                            <CircleButton
                                className={buttonClassName}
                                icon={icon || "more"}
                                primary={primary}
                                disabled={disabled}
                                data-testid={this.props["data-testid"]}
                            />
                        </PopoverTrigger>
                    )}

                    <div className={styles.menu}>
                        <PopoverContent
                            className="bg-transparent p-0 w-full min-w-full"
                            align="end"
                            side="bottom"
                        >
                            <Menu
                                legacy={false}
                                onClose={() => this.handleOpenChange(false)}
                                preventCloseOnBlur={true}
                                visible={this.open}
                                items={items}
                                data-testid={this.props["data-testid"]}
                            />
                        </PopoverContent>
                    </div>
                </Popover>

                {items.map(
                    ({ hotkey, label, value, onSelected }) =>
                        hotkey &&
                        (label || value) &&
                        onSelected && (
                            <Hotkey
                                key={`hotkey ${label || value}`}
                                code={hotkey}
                                label={label || value}
                                onHotkey={onSelected}
                            />
                        ),
                )}
            </div>
        );
    }
}
